import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchNoficationsRequest,
  UpdateNotificationsRequest,
  FetchNotificationsCountRequest,
  MarkAllNotificationsReadRequest,
  DeleteNotificationRequest,
} from './types'
import {
  fetchNotificationsUrl,
  updateNotificationUrl,
  notificationsCountUrl,
  markAllNotificationsReadUrl,
  deleteNotificationUrl,
} from '../../api'
import axios, {AxiosError} from 'axios'

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (payload: FetchNoficationsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchNotificationsUrl}?recipient=${payload.recipient}`)
      return {
        success: true,
        notifications: res.data.notifications,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

/** GET /api/notifications/count — unread count for badge */
export const fetchNotificationsCount = createAsyncThunk(
  'notifications/fetchCount',
  async (payload: FetchNotificationsCountRequest, {rejectWithValue}) => {
    try {
      const qs = payload.recipient ? `?recipient=${payload.recipient}` : ''
      const res = await axios.get(`${notificationsCountUrl}${qs}`)
      return { unreadCount: res.data.unreadCount ?? 0 }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateNotification = createAsyncThunk(
  'notifications/updateNotification',
  async (payload: UpdateNotificationsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateNotificationUrl, payload)
      return {
        status: 'success',
        data: res.data,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

/** POST /api/notifications/mark-all-read — mark all as read for recipient */
export const markAllNotificationsRead = createAsyncThunk(
  'notifications/markAllRead',
  async (payload: MarkAllNotificationsReadRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(markAllNotificationsReadUrl, payload)
      return {
        success: res.data.success !== false,
        modifiedCount: res.data.modifiedCount ?? 0,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

/** DELETE /api/notifications/:id — soft-delete one notification */
export const deleteNotification = createAsyncThunk(
  'notifications/deleteNotification',
  async (payload: DeleteNotificationRequest, {rejectWithValue}) => {
    try {
      const res = await axios.delete(deleteNotificationUrl(payload.id))
      return { id: payload.id, notification: res.data.notification }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
